import { render, staticRenderFns } from "./NowChat.vue?vue&type=template&id=cd9b63c8&scoped=true&"
import script from "./NowChat.vue?vue&type=script&lang=js&"
export * from "./NowChat.vue?vue&type=script&lang=js&"
import style0 from "./NowChat.vue?vue&type=style&index=0&id=cd9b63c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9b63c8",
  null
  
)

export default component.exports